export default __webpack_public_path__ + "static/media/Sanchi.95d051ea.jpg";